import { render, staticRenderFns } from "./TablePaginatedPhones.vue?vue&type=template&id=875ab5f6&scoped=true"
import script from "./TablePaginatedPhones.vue?vue&type=script&lang=js"
export * from "./TablePaginatedPhones.vue?vue&type=script&lang=js"
import style0 from "./TablePaginatedPhones.vue?vue&type=style&index=0&id=875ab5f6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875ab5f6",
  null
  
)

export default component.exports